import { CallbackSaga, createGeneralCall } from '@altermaind/core/requests-status-management';
import { GenericPost } from '@/_shared/types';
import { GenericApiError } from '@/_shared/types/apiError';
import { getCurrentOrganization } from '@/core/state/selectors';
import { API_ORGANIZATIONS_ORGANIZATIONID_CONTACTS_PATH_KEY } from '@/swagger/constants/slash-keys';
import { API_POST_CONTACT, KEY_POST_CONTACT } from '../constants';

type RequestPostContact = GenericPost<
  typeof API_ORGANIZATIONS_ORGANIZATIONID_CONTACTS_PATH_KEY
>['request']['body'];

export type CallParamsPostContact = RequestPostContact & {
  successSaga?: CallbackSaga;
  errorSaga?: CallbackSaga;
};

type CallResponsePostContact = GenericPost<
  typeof API_ORGANIZATIONS_ORGANIZATIONID_CONTACTS_PATH_KEY
>['response']['body'];

type CallErrorPostContact = GenericApiError;

type CallSelectorsPostContact = unknown;

const responseMapper = () => ({
  status: 'OK',
});

export const postContactCall = createGeneralCall<
  CallParamsPostContact,
  CallResponsePostContact,
  CallErrorPostContact,
  CallSelectorsPostContact
>({
  id: KEY_POST_CONTACT,
  url: () => state => {
    const org = getCurrentOrganization(state);
    return API_POST_CONTACT(org as unknown as string);
  },
  method: 'post',
  paramsSelector:
    ({ payload }) =>
    () => {
      return {
        ...payload,
      };
    },
  responseMapper,
  responseExtractor: null,
});
